import React, { useState, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import { CloseIcon, IdenifyIcon, ArrowRightIcon, CommentInfoIcon, QouteStart, QouteEnd } from 'ui-component/custom-icons/icons'

import CommentBadge from '../components/CommentBadge';

// ✅ Clear
const GradingModal = ({ openPopup, details, handleClose, handleProcessGrading }) => {

    const [gradeList, setGradeList] = useState(null);
    const [selectedItems, setSelectedItems] = useState([]);
    

    useEffect(() => {

        api.getSelectOptionsList('grade').then((res) => {
            if (res?.data) {
                const grades = res?.data?.map((item) => { 
                    item.label = item.name;
                    item.value = item.id;
                    return item;
                });
                setGradeList(grades);
            }
        });
        initializeItems()
    }, []);
    

    const initializeItems = () => {
        const checkedItems = details?.filter((item) => item.isChecked);
        // // Do something with checkedItems
        setSelectedItems(checkedItems);
    }

    const handleChangeGrade = (e, itemId) => {
        const updatedItems = selectedItems.map((item) => {
            if (item.id === itemId) {
                return { ...item, oldGradeId: e.id, oldGradeName: e?.label };
            }
            return item;
        });
        setSelectedItems(updatedItems);
    }

    const showCommentSection = (index) => {
        setSelectedItems(prevItems => 
            prevItems.map((item, i) => 
                i === index ? { ...item, showComment: true } : item
            )
        );
    }
    
    const closeComment = (index) => {
        setSelectedItems(prevItems => 
            prevItems.map((item, i) => 
                i === index ? { ...item, showComment: false, comment: '' } : item
            )
        );
    }
    const updateCommentField = (e, index) => {
        setSelectedItems(prevItems => 
            prevItems.map((item, i) => 
                i === index ? { ...item, comment: e?.target?.value } : item
            )
        );
    }

    const saveComment = (index) => {
        setSelectedItems(prevItems => 
            prevItems.map((item, i) => 
                i === index ? { ...item, showComment: false } : item
            )
        );
    }

    const submitForm = () => {
        handleProcessGrading(selectedItems);
    }
    

    return (
        <Modal show={openPopup}  centered size="md">
            <Modal.Body>
                <div className="p-2">
                    <div style={{ padding: '20px' }}>
                        <div className="mb-2 ml-0 pl-0">

                            <div className="row">
                                <div className="col-12 text-center">
                                    <IdenifyIcon height={'80px'} width={'80px'} />
                                </div>
                            </div>
                            <button className="btn modal-close-icon" onClick={handleClose}>
                                <CloseIcon height={'16px'} width={'16px'} />
                            </button>
                        </div>

                        <div className="row align-items-top">
                            <div className="col-12 text-center " style={{ padding: '10px 0 20px 0' }}>
                                <div style={{ fontSize: '24px' }}>
                                    Identify Grading
                                </div>
                                <div>
                                    Select new grade for selected IMEIs
                                </div>
                            </div>
                        </div>
                        {
                            selectedItems?.length > 0 && (
                                selectedItems?.map((item, index) => (
                                    <div className="row align-items-top">
                                        <div className="col-12 text-left " style={{ padding: '10px 0' }}>
                                            <div className="card">
                                                <div className="card-body">
                                                    {
                                                        item?.showComment == true ? (
                                                            <div className="comment-section" style={{ marginTop: '-15px', marginBottom: '-10px' }}>
                                                                                                                                    
                                                                <div className="section-head row" style={{ paddingLeft: '0', marginBottom: '5px' }}>
                                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px' }} className="col-md-4">
                                                                        Comment
                                                                    </div>
                                                                    <div className="actions col-md-8">
                                                                        <div 
                                                                            className='cursor-pointer'
                                                                            onClick={() => closeComment(index)}
                                                                        >
                                                                            <CloseIcon height={'12px'} width={'12px'} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                {
                                                                    (item?.hasComment) ? (
                                                                        <div className="row" style={{ marginBottom: '10px' }}>
                                                                            <div className="col-12 d-flex">
                                                                                <div style={{marginTop: '-5px' }}><QouteStart /></div>
                                                                                {item?.comment}
                                                                                <div style={{marginTop: '-5px' }}><QouteEnd /></div>
                                                                            </div>
                                                                        </div>         
                                                                    ) : (
                                                                        <>
                                                                                
                                                                            <div className="row">
                                                                                <div className="col-12">
                                                                                    <textarea
                                                                                        className='form-control'
                                                                                        rows="2"
                                                                                        value={item?.comment}
                                                                                        onChange={(e) => {
                                                                                            updateCommentField(e, index);
                                                                                        }}
                                                                                        style={{ resize: 'none' }}
                                                                                    />
                                                                                </div>
                                                                            </div>                                                          
                                                                            <div className="section-head row" style={{ paddingLeft: '0 !important'}}>
                                                                                <div style={{ display: 'flex', alignItems: 'center', gap: '5px', fontSize: '13px' }} className="col-md-4">
                                                                                    
                                                                                </div>
                                                                                <div className="actions col-md-8">
                                                                                    <button type="button" onClick={() => saveComment(index)} className="btn btn-primary btn-outlined-main">
                                                                                        Save Comment 
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </>
                                                                    )
                                                                }
                                                            </div>
                                                        ) : (
                                                            <>
                                                                    
                                                                <div className="row detail-section">
                                                                    <div className="col-12 d-flex justify-content-between">
                                                                        <div className="font15">
                                                                                {item?.imei}
                                                                        </div>
                                                                        <div>
                                                                            <div
                                                                                className="cursor-pointer"
                                                                                // className="btn btn-main-primary btn-outlined-main"
                                                                                style={{ marginRight: '8px' }}
                                                                                // disabled={!selectedRepairs}
                                                                                onClick={() => {
                                                                                    showCommentSection(index);
                                                                                }}
                                                                                >
                                                                                    <CommentInfoIcon height='20' width='20' />
                                                                                    {
                                                                                        (item?.hasComment || (item?.comment != '' && item?.comment != null && item?.comment !== undefined)) && (
                                                                                            <CommentBadge count="1" />
                                                                                        )
                                                                                    }
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-12 textGray" style={{ margin: '5px 0' }}>
                                                                        {item?.productName} {item?.colorName ? `${item?.colorName}` : `` }
                                                                    </div>
                                                                </div>
                                                                <div className="row">
                                                                    <div className="col-5">
                                                                        <input type="text" value={item?.newGradeName} disabled className='form-control' />
                                                                    </div>
                                                                    <div className="col-2 d-flex justify-content-center align-items-center">
                                                                        <ArrowRightIcon height='28px' width='28px' />
                                                                    </div>
                                                                    <div className="col-5">
                                                                        <Select
                                                                            options={gradeList}
                                                                            className="rs-container"
                                                                            classNamePrefix="rs"
                                                                            placeholder="Select or type..."
                                                                            isMulti={false}
                                                                            onChange={(e) => {
                                                                                handleChangeGrade(e, item?.id)
                                                                            }}
                                                                            value={gradeList?.find(option => option.id === item.oldGradeId) || null}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </>
                                                        )
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))
                            )
                        }
                        <div className="btnarea" style={{ justifyContent: 'center', marginTop: '20px' }}>

                            <div className="row">
                                <div className="col-12 text-center" style={{ display: 'flex', justifyContent: 'right' }}>
                                    <button
                                        className="btn btn-main-primary btn-outlined-main"
                                        style={{ marginRight: '8px' }}
                                        onClick={() => {
                                            submitForm();
                                        }}
                                    >
                                        Save 
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default GradingModal;
